import React from 'react';
import styles from './ProjectList.module.scss';
import { getProjectHealthStatus } from '../ReportMetrics/reportData';

interface ProjectScoreCellProps {
  /** 0-100, or undefined when the KPI was not computable. */
  value?: number;
}

/**
 * One KPI score in the Dashboard's project list, coloured by the same health
 * bands the Project Intelligence pages use so a number reads the same
 * everywhere.
 *
 * A score that was not computable is a muted dash (spec §3.3) - a 0% here
 * would report a failing project where there is simply nothing measured.
 */
const ProjectScoreCell: React.FC<ProjectScoreCellProps> = ({ value }) => {
  if (typeof value !== 'number') {
    return <span className={styles.scoreUnknown}>—</span>;
  }

  const { color } = getProjectHealthStatus(value);
  return (
    <span className={styles.scoreValue} style={{ color }}>
      {Math.round(value)}%
    </span>
  );
};

export default ProjectScoreCell;
